import { VText } from '@vake/ui-kit';
import { FC } from 'react';

const companies = [
    {
        title: 'NATO',
        img: 'images/icons/Recognized/Nato.png',
        text: (
            <>
                Winners of the{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.ncia.nato.int/about-us/newsroom/nci-agency-announces-winners-of-2019-annual-defence-innovation-challenge.html"
                >
                    Innovation Challenge
                </a>{' '}
                at NATOs tech conference in 2019
            </>
        ),
    },
    {
        title: 'ESA',
        img: 'images/icons/Recognized/Esa.png',
        text: (
            <>
                Winners of{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.esa.int/Applications/Observing_the_Earth/Copernicus/Vake_Catch_wins_2019_Space_App_Camp#:~:text=An%20app%20that%20will%20help,observation%20centre%20in%20Frascati%2C%20Italy"
                >
                    ESA app camp 2019
                </a>{' '}
                and part of their Business Incubation Center in Norway
            </>
        ),
    },
    {
        title: 'Airbus',
        img: 'images/icons/Recognized/Airbus.png',
        text: <> Partnership agreement with Airbus’ subsidiary UP42, for access to Airbus imagery</>,
    },
    {
        title: 'Techstars',
        img: 'images/icons/Recognized/Techstars.png',
        text: (
            <>
                Part of{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://demoday.techstars.com/allied-space-2020-t3?c=vake"
                >
                    Techstars Allied Space Accelerator Program
                </a>
                , in partnership with US Air Force, Norwegian and Dutch DoDs
            </>
        ),
    },
    {
        title: 'Socom',
        img: 'images/icons/Recognized/Socom.png',
        text: <>Part of a Rapid Capability Assessment initative run by Liberty Alliance, LLC for delivery to SOCOM</>,
    },
    {
        title: 'Norsk romsenter',
        img: 'images/icons/Recognized/NorskRomsenter.png',
        text: <>Project funding to evaluate onboard processing for Vake’s algorithm</>,
    },
    {
        title: 'AF Werx',
        img: 'images/icons/Recognized/Afwerx.png',
        text: <>Selected by AF Werx Persistent ISR Challenge as a collaborator</>,
    },
    {
        title: 'Nifro',
        img: 'images/icons/Recognized/Nifro.png',
        text: (
            <>
                Awarded the{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.narom.no/nyheter/lars-henrik-berg-jensen-og-adrian-tofting-fra-ntnu-vant-arets-nifro-pris/"
                >
                    Norwegian Space Industry’s award for best master thesis
                </a>{' '}
                in 2018
            </>
        ),
    },
];

const RecognizedBy: FC = () => (
    <div className="flex flex-col max-w-[1225px]">
        <div
            className="
                        grid 
                        grid-cols-4 
                        gap-4
                        [grid-template-rows:200px_200px] 
                        "
        >
            {companies.map((company, i) => {
                const imageKey = `company_${i}`;
                return (
                    <div className="flex flex-col justify-center text-center items-center gap-4" key={imageKey}>
                        <div className="max-w-[120px] max-h-[75px]">
                            <img src={company.img} alt={`${company.title}`} />
                        </div>

                        <VText variant="D1">{company.text}</VText>
                    </div>
                );
            })}
        </div>
    </div>
);

export default RecognizedBy;
